import styled from 'styled-components'

interface StyledPrimaryContactFormSectionProps {
  $disabled?: boolean
}

export const StyledPrimaryContactFormSection = styled.div<StyledPrimaryContactFormSectionProps>`
  ${({ $disabled }) => $disabled && `  
    opacity: 0.5;
    cursor: not-allowed;
  `}
`
